import { render, staticRenderFns } from "./onlineService.vue?vue&type=template&id=38bf86f5&scoped=true&"
import script from "./onlineService.vue?vue&type=script&lang=js&"
export * from "./onlineService.vue?vue&type=script&lang=js&"
import style0 from "./onlineService.vue?vue&type=style&index=0&id=38bf86f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf86f5",
  null
  
)

export default component.exports